import { render, staticRenderFns } from "./tipsbox.vue?vue&type=template&id=707eb94d&scoped=true"
import script from "./tipsbox.vue?vue&type=script&lang=js"
export * from "./tipsbox.vue?vue&type=script&lang=js"
import style0 from "./tipsbox.vue?vue&type=style&index=0&id=707eb94d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707eb94d",
  null
  
)

export default component.exports